import request from '@/plugin/axios'

export function page(query) {
    return request({
        url: '/api/case/czExecute/page',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/api/case/czExecute/addExecuteMessage',
        method: 'post',
        data: obj
    })
}

export function getExecutePlan(id) {
    return request({
        url: '/api/case/czExecute/getOneExecuteMessage/' + id,
        method: 'get'
    })
}

export function delExe(id) {
    return request({
        url: '/api/case/czExecute/delExe/' + id,
        method: 'delete'
    })
}

export function putObj(obj) {
    return request({
        url: '/api/case/czExecute/updateExecuteMessage',
        method: 'post',
        data: obj
    })
}

export function submitExeCase(obj){
    return request({
        url: '/api/case/czExecute/submitExeCase',
        method: 'put',
        data:obj
    })
}

export function submitExeInfo(obj){
    return request({
        url: '/api/case/czExecute/submitExeInfo',
        method: 'put',
        data: obj
    })
}

export function submitExeFile(obj){
    return request({
        url: '/api/case/czExecute/submitExeFile',
        method: 'put',
        data: obj
    })
}
